import { LinkFieldValue } from "@sitecore-jss/sitecore-jss-react/types/components/Link";
import { ImageField, LinkField, StringField } from "../../../types/types";
import {
  CardsCarouselModuleFields,
  CardsCarouselModuleProps,
} from "../types/CardsCarouselModule.types";

export class CardsCarouselModuleModel {
  private readonly fields?: CardsCarouselModuleFields;
  private readonly params?: CardsCarouselModuleFields;
  constructor(props: CardsCarouselModuleProps) {
    this.fields = props.fields || null;
    this.params = props.params || null;
  }

  get theme(): StringField {
    return this.params?.Theme;
  }

  get List(): any {
    return this.fields?.List;
  }

}
